module.exports = __webpack_public_path__ + "static/media/routing.a86bfee1.png";